import styled from 'styled-components'

export const ContentMedicine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const TextMedicine = styled.div``

export const ContentLoading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 32px 0;
  padding: 0 48px;
  text-align: center;
`
